import React, { Component } from 'react'
import { connect } from 'react-redux'
import Row from './Row'
import Form from './Form'
import css from './styles.scss'

export class AccessTokens extends Component {
  constructor (props) {
    super(props)
    this.state = {
      accessTokens: [],
      loading: false,
      creating: false,
      showModal: false,
      showContact: false
    }
    this.controller = AbortController ? new AbortController() : {}
  }

  componentWillUnmount () {
    this.controller.abort()
  }

  componentDidMount () {
    fetch('/api/v1/access_tokens', {
      method: 'GET',
      signal: this.controller.signal,
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          console.assert(data._error)
          return false
        }
        this.setState({ accessTokens: data.results })
      })
  }

  delete = id => {
    if (id) {
      this.setState({ loading: true })
      fetch(`/api/v1/access_tokens/${id}`, {
        method: 'DELETE',
        signal: this.controller.signal,
        headers: {
          Authorization: `Bearer ${this.props.auth.bearerToken}`
        }
      })
        .then(res => {
          if (res.status === 200) {
            return true
          }
          return false
        }).then(success => {
          this.setState({ loading: false })
          if (success) {
            const results = this.state.accessTokens
            const index = results.map(token => { return token.id }).indexOf(id)
            results.splice(index, 1)
            this.setState({ accessTokens: results })
          }
        })
    }
  }

  regenerate = id => {
    if (id) {
      this.setState({ loading: true })
      fetch(`/api/v1/access_tokens/${id}/regenerate`, {
        method: 'GET',
        signal: this.controller.signal,
        headers: {
          Authorization: `Bearer ${this.props.auth.bearerToken}`
        }
      })
        .then(res => {
          if (res.status === 200) {
            return res.json()
          }
          return {
            _error: res.statusText
          }
        }).then(data => {
          if (data._error) {
            console.assert(data._error)
            return false
          }
          const newBearerToken = data.bearerToken

          if (newBearerToken) {
            const results = this.state.accessTokens
            const index = results.map(token => { return token.id }).indexOf(id)
            results[index].bearerToken = newBearerToken
            this.setState({ accessTokens: results })
          }

          this.setState({ loading: false })
        })
    }
  }

  handleCreate = () => {
    if (this.props.user.roles && this.props.user.roles.indexOf('partner') > -1) {
      this.setState({ creating: true })
    } else {
      this.setState({ showContact: true })
    }
  }

  handleCancelCreate = () => {
    this.setState({ creating: false })
  }

  addNewToken = (newToken) => {
    const results = [newToken, ...this.state.accessTokens]
    this.setState({
      accessTokens: results,
      creating: false
    })
  }

  showModal = () => {
    this.setState({ showModal: true })
  }

  hideModal = () => {
    this.setState({ showModal: false })
  }

  render () {
    const tokens = []
    const { accessTokens, showContact } = this.state

    accessTokens.sort((token1, token2) => {
      return token1.createdAt < token2.createdAt
    })

    for (let i = 0, len = accessTokens.length; i < len; i++) {
      const token = accessTokens[i]

      const comProps = {
        delete: this.delete,
        regenerate: this.regenerate,
        key: token.id,
        id: token.id,
        createdAt: (new Date(Number(token.createdAt))).toString().split(' GMT')[0],
        name: token.name,
        isRead: Boolean(token.permissions.indexOf('read') !== -1),
        isWrite: Boolean(token.permissions.indexOf('write') !== -1)
      }

      const tokenCom = (
        <Row
          {...comProps}
        />
      )

      tokens.push(tokenCom)

      if (token.bearerToken) {
        const bearerTokenCom = (
          <div key={token.id + '_bearerToken'} className={css.showToken}>{token.bearerToken}</div>
        )
        tokens.push(bearerTokenCom)
      }
    }

    let creationCom
    if (this.state.creating) {
      creationCom = (<Form addNewToken={this.addNewToken} bearerToken={this.props.auth.bearerToken} onHandleCancelCreate={this.handleCancelCreate} />)
    } else {
      creationCom = (
        <div className={css.create}>
          <button onClick={this.handleCreate} className={css.button}>Create an access token</button>
          <p className={css.p} style={{ display: showContact ? 'inline-block' : 'none' }}>
            To create a SmartItem please contact Benjamin Hunter: <a href='mailto:Benjamin.Hunter@caveon.com'>Benjamin.Hunter@caveon.com</a>
          </p>
        </div>
      )
    }

    return (
      <div className={css.container}>
        <div className={css.pageTools}>
          <div className={CSS.newForm}>
            {creationCom}
          </div>
        </div>
        <div className={css.table}>
          <div className={css.tableRow}>
            <div>Name</div>
            <div />
            <div>Created</div>
            <div>Read</div>
            <div>Write</div>
            <div />
          </div>
          {tokens}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { auth, user } = state
  return {
    auth,
    user
  }
}

export default connect(mapStateToProps)(AccessTokens)



// WEBPACK FOOTER //
// /app/js/components/AccessTokens/index.js